import React from "react";
import cont from "../assets/terms.json";
import contEn from "../assets/terms_en.json";
import contJp from "../assets/terms_jp.json";
import { Textarea, Flex } from "@chakra-ui/react";
import { Header1 } from "../components/Header";
import { Dialog } from "../components/Dialog";
import { Large } from "../components/Type";
import { SingleFormAppShell } from "../components/SingleFormAppShell";
import { Trans, t, msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { loadCatalog } from "../i18n";
import Head from "../components/Head";

export async function getStaticProps({ params, ...ctx }) {
  const translation = await loadCatalog(ctx.locale);
  return { props: { translation } };
}

const Terms = () => {
  const { terms } = cont;
  const { terms_en } = contEn;
  const { terms_jp } = contJp;

  const { i18n } = useLingui();

  const termsLocalized = (() => {
    switch (i18n.locale) {
      case "id":
        return terms;
      case "ja":
        return terms_jp;
      case "en":
        return terms_en;
      default:
        return terms;
    }
  })();

  return (
    <>
    <SingleFormAppShell title={t`Syarat dan Ketentuan`} description={t`Baca syarat dan ketentuan penggunaan Saweria untuk memahami syarat, ketentuan, serta aturan dalam menggunakan layanan kami.`}>
      <Flex
        paddingX={["4", 0, 0]}
        alignItems="center"
        justifyContent="center"
        minH="100vh"
        direction="column"
      >
        <Flex justifyContent="center" direction="column">
          <Header1 />
          <Dialog w={["100%"]} marginTop={3}>
            <Large m={3} alignSelf="center">
              <Trans>Syarat dan Ketentuan</Trans>
            </Large>
            <Textarea
              h={"50vh"}
              backgroundColor="transparent"
              variant="flused"
              disabled
              value={termsLocalized}
            ></Textarea>
          </Dialog>
        </Flex>
      </Flex>
    </SingleFormAppShell>
    </>
  );
};

export default Terms;
